export function displayAppLoadingError(err) {
    const loadingLoader = document.querySelector('[data-loader-loading]');
    const errorLoader = document.querySelector('[data-loader-error]');

    if (!loadingLoader || !errorLoader) {
        throw new Error(err);
    }

    loadingLoader.classList.add('hidden');
    errorLoader.classList.remove('hidden');
}
